/**
 * FILE: assets/katanashop.js
 *
 * All interactive behaviour for KatanaShop:
 *   1. Magic-line nav hover indicator
 *   2. Language switcher (EN / KA) — desktop toggle + mobile dropdown
 *   3. Best Sellers slider (keyboard + touch swipe)
 *   4. Reviews slider (keyboard + touch swipe + dot navigation)
 *   5. FAQ accordion
 *   6. Add-to-Cart (AJAX) with live cart count updates
 *   7. Resize reset
 */

(function () {
  'use strict';

  
  /* ════════════════════════════
     UNDER CONSTRUCTION MODAL
  ════════════════════════════ */

  const modal = document.getElementById('construction-modal');

  function modalLang() {
    return document.body.classList.contains('lang-ka') ? 'ka' : 'en';
  }

  function applyModalLang() {
    if (!modal) return;
    const lang = modalLang();
    modal.querySelectorAll('[data-en][data-ka]').forEach(el => {
      el.textContent = el.getAttribute('data-' + lang);
    });
  }

  function openModal() {
    if (!modal) return;
    applyModalLang();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  if (modal) {
    new MutationObserver(applyModalLang).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close')) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  document.addEventListener('click', function (e) {
    const el = e.target.closest('a, button');
    if (!el) return;

    if (
      el.classList.contains('slider-btn') ||
      el.classList.contains('rev-btn') ||
      el.classList.contains('soc-btn') ||
      el.classList.contains('lang-mob-btn') ||
      el.classList.contains('lang-mob-opt')
    ) return;

    if (el.closest('#construction-modal')) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    openModal();
  }, true);
  




  /* ════════════════════════════
     MAGIC LINE NAV
  ════════════════════════════ */
  
  const navLinksContainer = document.getElementById('nav-links');
  const magicLine = document.getElementById('nav-magic-line');

  if (navLinksContainer && magicLine) {
    const navAnchors = Array.from(navLinksContainer.querySelectorAll('a'));

    function moveMagicLine(el) {
      const left = el.offsetLeft;
      const width = el.offsetWidth;
      const padH = 16;
      magicLine.style.left  = left + padH + 'px';
      magicLine.style.width = width - padH * 2 + 'px';
      magicLine.style.opacity = '1';
    }

    navAnchors.forEach((a) => {
      a.addEventListener('mouseenter', () => moveMagicLine(a));
    });

    navLinksContainer.addEventListener('mouseleave', () => {
      magicLine.style.opacity = '0';
    });
  }

  /* ════════════════════════════
     DESKTOP LANGUAGE INDICATOR
  ════════════════════════════ */
  const langToggle  = document.getElementById('lang-toggle');
  const langKaBtn   = document.getElementById('lang-ka-btn');
  const langEnBtn   = document.getElementById('lang-en');
  const langIndicator = document.getElementById('lang-indicator');

  function moveLangIndicator(activeEl) {
    if (!langIndicator || !activeEl) return;
    langIndicator.style.left  = activeEl.offsetLeft + 2 + 'px';
    langIndicator.style.width = activeEl.offsetWidth - 4 + 'px';
  }

  /* ════════════════════════════
     LANGUAGE HANDLER — unified
  ════════════════════════════ */
  let currentLang = 'EN';

  function applyLang(lang) {
    currentLang = lang;
    const isKa = lang === 'KA';

    document.body.classList.toggle('lang-ka', isKa);

    document.querySelectorAll('[data-en]').forEach((el) => {
      const val = isKa ? el.dataset.ka : el.dataset.en;
      if (!val) return;

      if (el.classList.contains('btn-primary')) {
        const svg = el.querySelector('svg');
        el.textContent = val;
        if (svg) el.appendChild(svg);
      } else if (el.tagName === 'INPUT') {
        el.placeholder = val;
      } else if (el.tagName === 'DIV' && el.classList.contains('cat-name')) {
        el.textContent = val;
      } else if (el.tagName === 'DIV' && el.classList.contains('trust-number')) {
        if (el.dataset.en === 'FREE SHIPPING') {
          if (isKa) {
            el.textContent = 'უფასო მიწოდება';
          } else {
            el.innerHTML = 'FREE<em> SHIPPING</em>';
          }
        }
      } else {
        el.textContent = val;
      }
    });

    if (langKaBtn) langKaBtn.classList.toggle('active', isKa);
    if (langEnBtn) langEnBtn.classList.toggle('active', !isKa);
    moveLangIndicator(isKa ? langKaBtn : langEnBtn);

    const langMobBtn = document.getElementById('lang-mob-btn');
    if (langMobBtn) langMobBtn.textContent = isKa ? 'KA' : 'ENG';

    document.querySelectorAll('.lang-mob-opt').forEach((o) => {
      o.classList.toggle('active', o.dataset.lang === (isKa ? 'KA' : 'ENG'));
    });
  }

  if (langEnBtn && langKaBtn) {
    [langEnBtn, langKaBtn].forEach((el) => {
      el.addEventListener('click', () => applyLang(el.dataset.lang));
    });
  }

  const langMobBtn = document.getElementById('lang-mob-btn');
  const langMobDd  = document.getElementById('lang-mob-dd');

  if (langMobBtn && langMobDd) {
    langMobBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      langMobDd.classList.toggle('open');
    });

    document.querySelectorAll('.lang-mob-opt').forEach((opt) => {
      opt.addEventListener('click', () => {
        langMobDd.classList.remove('open');
        applyLang(opt.dataset.lang);
      });
    });

    document.addEventListener('click', () => langMobDd.classList.remove('open'));
  }

  window.addEventListener('load', () => applyLang('EN'));
  setTimeout(() => moveLangIndicator(langEnBtn), 50);

  /* ════════════════════════════
     BEST SELLERS SLIDER
  ════════════════════════════ */
  const bsTrack = document.getElementById('bs-track');

  if (bsTrack) {
    const bsCards = Array.from(bsTrack.querySelectorAll('.product-card'));
    let bsIdx = 0;
    const bsGap = 24;

    function bsVisible() { return window.innerWidth <= 900 ? 2 : 3; }
    function bsMax()     { return Math.max(0, bsCards.length - bsVisible()); }
    function bsCardW()   { return bsCards[0].offsetWidth + bsGap; }

    function bsGo(dir) {
      bsIdx = Math.max(0, Math.min(bsIdx + dir, bsMax()));
      let translateVal = bsIdx * bsCardW();
      const maxTranslate = Math.max(0, bsTrack.scrollWidth - bsTrack.parentElement.clientWidth);
      if (translateVal > maxTranslate) translateVal = maxTranslate;
      bsTrack.style.transform = `translateX(-${translateVal}px)`;
    }

    const bsPrev = document.getElementById('bs-prev');
    const bsNext = document.getElementById('bs-next');
    if (bsPrev) bsPrev.addEventListener('click', () => bsGo(-1));
    if (bsNext) bsNext.addEventListener('click', () => bsGo(1));

    /* Touch swipe */
    addSwipe(bsTrack, () => bsGo(1), () => bsGo(-1));

    window.addEventListener('resize', () => {
      bsIdx = 0;
      bsTrack.style.transform = 'translateX(0)';
    });
  }

  /* ════════════════════════════
     REVIEWS SLIDER
  ════════════════════════════ */
  const revTrack = document.getElementById('rev-track');
  const revDots  = Array.from(document.querySelectorAll('.rev-dot'));
  let revIdx = 0;

  if (revTrack) {
    const revCards = Array.from(revTrack.querySelectorAll('.rev-card'));

    function revVisible() { return window.innerWidth <= 900 ? 1 : 3; }
    function revMax()     { return Math.max(0, revCards.length - revVisible()); }
    function revCardW()   { return revCards[0].offsetWidth + 16; }

    function revGo(dir) {
      revIdx = Math.max(0, Math.min(revIdx + dir, revMax()));
      revTrack.style.transform = `translateX(-${revIdx * revCardW()}px)`;
      revDots.forEach((d, i) => d.classList.toggle('active', i === revIdx));
    }

    const revPrev = document.getElementById('rev-prev');
    const revNext = document.getElementById('rev-next');
    if (revPrev) revPrev.addEventListener('click', () => revGo(-1));
    if (revNext) revNext.addEventListener('click', () => revGo(1));

    revDots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        revIdx = i;
        revTrack.style.transform = `translateX(-${revIdx * revCardW()}px)`;
        revDots.forEach((d, j) => d.classList.toggle('active', j === revIdx));
      });
    });

    addSwipe(revTrack, () => revGo(1), () => revGo(-1));

    window.addEventListener('resize', () => {
      revIdx = 0;
      revTrack.style.transform = 'translateX(0)';
      revDots.forEach((d, i) => d.classList.toggle('active', i === 0));
      moveLangIndicator(currentLang === 'KA' ? langKaBtn : langEnBtn);
    });
  }

  /* ════════════════════════════
     TOUCH SWIPE HELPER
  ════════════════════════════ */
  function addSwipe(el, onLeft, onRight) {
    let sx = 0;
    el.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend',   (e) => {
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) dx < 0 ? onLeft() : onRight();
    }, { passive: true });
  }

  /* ════════════════════════════
     FAQ ACCORDION
  ════════════════════════════ */
  document.querySelectorAll('.faq-item').forEach((item) => {
    const q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach((i) => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ════════════════════════════
     ADD TO CART — AJAX
     Uses Shopify's Cart API. On success, updates all cart count badges
     across nav and FAB without a page reload.
  ════════════════════════════ */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.atc');
    if (!btn) return;

    const variantId = btn.dataset.productId;
    if (!variantId) return;

    btn.textContent = currentLang === 'KA' ? 'ემატება...' : 'ADDING...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => res.json())
      .then(() => {
        // Refresh cart item count from Shopify
        return fetch('/cart.js');
      })
      .then((res) => res.json())
      .then((cart) => {
        const count = cart.item_count;
        // Update all cart count displays
        document.querySelectorAll('.nav-cart-text').forEach((el) => {
          el.dataset.en = `CART (${count})`;
          el.dataset.ka = `კალათა (${count})`;
          el.textContent = currentLang === 'KA' ? `კალათა (${count})` : `CART (${count})`;
        });
        const fabBadge = document.getElementById('fab-badge');
        if (fabBadge) fabBadge.textContent = count;

        btn.textContent = currentLang === 'KA' ? 'დამატებულია' : 'ADDED';
        setTimeout(() => {
          btn.textContent = currentLang === 'KA' ? 'კალათაში დამატება' : 'ADD TO CART';
          btn.disabled = false;
        }, 1400);
      })
      .catch(() => {
        btn.textContent = currentLang === 'KA' ? 'შეცდომა' : 'ERROR';
        setTimeout(() => {
          btn.textContent = currentLang === 'KA' ? 'კალათაში დამატება' : 'ADD TO CART';
          btn.disabled = false;
        }, 1400);
      });
  });

})();
